module.exports = __webpack_public_path__ + "img/Patient Counselling.a4b145b0.jpg";